"use client";

import { useEffect, useState } from "react";

interface EmailLinkProps {
	className?: string;
	children: React.ReactNode;
	user?: string;
	domain?: string;
}

export function EmailLink({
	className,
	children,
	user = "support",
	domain = "imagesart.ai",
}: EmailLinkProps) {
	const [email, setEmail] = useState<string>("");

	useEffect(() => {
		// 在客户端动态组装邮箱地址，避免 Cloudflare 自动替换
		setEmail(`${user}@${domain}`);
	}, [user, domain]);

	if (!email) {
		// 初始渲染时显示为普通文本，避免闪烁
		return <span className={className}>{children}</span>;
	}

	return (
		<a href={`mailto:${email}`} className={className}>
			{children}
		</a>
	);
}
